import Model, { JsonObject } from 'src/models/model'

export default class GitRelease extends Model {
  static name = 'GitRelease'

  static noId = true

  static define () {
    this.fields = {
      tag: {
        type: String,
        required: false
      },
      markdown: {
        type: String,
        required: false
      },
      stats: {
        type: JsonObject,
        required: false
      },
      repo: {
        type: String,
        input: true,
        default: 'indy-api'
      }
    }

    this.queries = {
      gitReleases: {
        arguments: {
          repo: {
            type: String,
            required: true
          }
        },
        results: {
          gitReleases: [GitRelease]
        }
      }
    }
  }

  get repoOptions () {
    return [
      { label: 'Testing', value: 'deployment-test' },
      { label: 'Backend', value: 'indy-api' },
      { label: 'Frontend', value: 'indy-frontend' }
    ]
  }
}
